"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// This file is loaded on any page load.
var app_1 = require("app");
var cloningAlert_1 = require("./security/cloningAlert");
function main() {
    cloningAlert_1.default();
    initDynatraceTracking();
}
exports.default = main;
function initDynatraceTracking() {
    var dtrum = window['dtrum'];
    // If opt-in is not enabled we can't control dynatrace monitoring.
    if (!dtrum || !dtrum.enable || !dtrum.disable)
        return;
    // Fires on CookieInformation init and then on changes in user consent.
    window.addEventListener('CookieInformationConsentGiven', function onCookieConsentChange() {
        var cookieCategoriesAcceptance = app_1.UtilService.getCookieCategoriesAcceptance();
        if (!cookieCategoriesAcceptance)
            return;
        if (cookieCategoriesAcceptance.functional) {
            dtrum.enable();
        }
        else {
            dtrum.disable();
        }
    });
}
